import React, { useState } from "react";
import Cropper from "react-easy-crop";
import getCroppedImg from "./cropImage";
import { useSelector } from "react-redux";
import { State } from "../../../redux/reducers/root";

interface IProps {
  image: any;
  setFinalImage: (image: any, zoom: any) => void;
}

const ImageCropper: React.FC<IProps> = (props) => {
  const { image, setFinalImage } = props;
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState<any>(1);
  const uploadedImages = useSelector((state: State) => state.profileImage);

  const showCroppedImage = async (croppedAreaPixels: any) => {
    try {
      const croppedImage = await getCroppedImg(image, croppedAreaPixels);
      setFinalImage(croppedImage, zoom);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  const onCropComplete = (croppedArea: any, croppedAreaPixels: any) => {
    showCroppedImage(croppedAreaPixels);
  };

  return (
    <div className="relative mt-3">
      <div className="h-[228px] w-full">
        <Cropper
          image={image}
          crop={crop}
          zoom={zoom}
          aspect={uploadedImages.type === "officeImage" ? 29 / 20 : 3 / 4}
          onCropChange={setCrop}
          onCropComplete={onCropComplete}
          onZoomChange={setZoom}
          restrictPosition={false}
        />
      </div>

      <div className="w-full absolute -bottom-[27px]">
        <input
          type="range"
          value={zoom}
          min={1}
          max={3}
          step={0.01}
          dir="ltr"
          aria-labelledby="Zoom"
          onChange={(e) => {
            setZoom(e.target.value);
          }}
          className="w-full h-2 bg-blue-500 rounded-full outline-none opacity-75 appearance-non"
        />
      </div>
    </div>
  );
};

export default ImageCropper;
